var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('li',{staticClass:"nav-link",attrs:{"data-active":_vm.isActive(_vm.href)}},[_c('a',{attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }